import * as angular from "angular";
import {IController} from "angular";
import {AgentModel} from "../../angular/models/agent.model";
import {TaskModel} from "../../../tasks/models/task.model";
import {SplitService} from "../../../commons/services/split-service.service";
import {LocationType} from "../../../commons/types/location.type";
import {TaskStatusType} from "../../../tasks/types/taskStatus.type";
import {TaskType} from "../../../tasks/types/task.type";

export class AgentRouteReportTasksComponent implements IController {

  agent: AgentModel;
  tasks: TaskModel[];

  public configZoneId: string;
  public locationTypes: typeof LocationType = LocationType;
  public taskType: typeof TaskType = TaskType;

  constructor(private splitService: SplitService) {}

  $onInit() {
    this.configZoneId = this.splitService.getTimeZone();
  }

  sliceId(id) {
    return id.slice(-4);
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentRouteReportTasks', {
    bindings: {
      agent: '<',
      tasks: '<'
    },
    template: require('./agent-route-report-tasks.html').default,
    controller: AgentRouteReportTasksComponent
  });
